import React, { AnchorHTMLAttributes } from 'react'

import { useT } from 'src/core/hooks/use-translation'

function Link({ title, ...props }: AnchorHTMLAttributes<HTMLAnchorElement>) {
  const { t } = useT()
  return <a {...props}>{t(title)}</a>
}

export default Link
